<template>
    <div class="page-layout blank contacts-manage pt-3">
        <div class="pb-10">
            <div style="overflow-x: auto;overflow-y: hidden;">
                <div class="d-flex align-items-center mob-list-scroll-ticket-details">
                    <div class='slant-tabs' :class="{'activeTab':active_tab == 'details','new-blue':active_tab == 'details'}" @click="selectViewDetail('details')">
                        <span>Details</span>  
                    </div>
                    <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'email','new-blue':active_tab == 'email'}" @click="selectViewDetail('email')">
                        <span>Email</span> 
                    </div>
                    <!-- is_parent_ticket -->
                    <!-- <div v-if="is_software_bug != 'Product Bug Template'">
                        <div v-if="loggedInUser.service_ticket_required == true && is_parent_ticket" class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'service','new-blue':active_tab == 'service'}" @click="selectViewDetail('service')">
                            <span>Service</span> 
                        </div>
                    </div> -->
                    <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'comment','new-blue':active_tab == 'comment'}" @click="selectViewDetail('comment')">
                    <span>Comment</span>
                    </div>
                    <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'activity','new-blue':active_tab == 'activity'}" @click="selectViewDetail('activity')">
                    <span>Activity</span> 
                    </div>
                </div>
            </div>
            <div class="vendor-list br-t-l-r py-2" id="printId">
                <!-- <div class="pb-2" style="border-bottom:1.5px solid #005dae">
                    <div class="d-flex align-items-center w-50">
                        <span class="text-secondary fw-600 mr-4"><span>Ticket</span> #50205</span>
                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/info-24px.svg" alt="" style="height:20px;">
                        <span class="text-secondary fw-600 ml-4">CRM Edit Bug Not Working</span>
                    </div>
                </div> -->
                <details-view @moveToEmail="moveToEmail" @ticketDetailsNotFound="ticketDetailsNotFound" @previewImage="previewImage" @previewImageTicketFix="previewImageTicketFix" @isSoftwareBugTemplate="isSoftwareBugTemplate" @templateProductData="templateProductData" v-if="active_tab == 'details'" :ticket_id="ticket_id" :list="list" :subject="subject" :ticket_number="ticket_number" :fromApproval="approval"></details-view>
                <ticket-email v-if="active_tab == 'email'" :ticket_id="ticket_id"></ticket-email>
                <ticket-comments v-if="active_tab == 'comment'" :is_archived="is_archived" :ticket_id="ticket_id" @previewImage="previewImage" :subject="subject" :ticket_number="ticket_number"></ticket-comments>
                <ticket-activity v-if="active_tab == 'activity'" :ticket_id="ticket_id"></ticket-activity>
                <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
            </div>
        </div>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event.js';
var mime = require('mime-types')
import ticket from '../mixins/ticket.js';
const DetailsView = () => import("./DetailsView");
const TicketEmail = () => import("../Tickets/TicketEmail.vue");
const TicketActivity = () => import("../Tickets/TicketActivity.vue");
const TicketComments = () => import("../Tickets/TicketComments.vue");
const Preview = () => import("../Preview");
export default {
    mixins:[ticket],
    props:['ticket_id','is_parent_ticket','subject','ticket_number','approval','list'],
    components:{
        DetailsView,
        TicketEmail,
        TicketActivity,
        TicketComments,
        Preview
    },
    data(){
        return{
            active_tab:'details',
            active_tab_body:"details",
            preview_file: '',
            preview_visible: false,
            is_software_bug: '',
            template_product_data: [],
            is_archived: false,
            ticket_details_not_found: false
        }
    },
    methods:{
        selectViewDetail(ticket_obj){
            if(this.ticket_details_not_found == false) {
                this.active_tab = ticket_obj
                this.active_tab_body = ticket_obj
            }
        },
        moveToEmail(){
            this.active_tab = 'email'
            this.active_tab_body = 'email'
        },
        hidePreview(){
            this.preview_visible = false
        },
        previewImage(file) {
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            this.preview_visible = true;
        },
        previewImageTicketFix(file) {
            this.previewImage(file);
        },
        isSoftwareBugTemplate(data) {
            this.is_software_bug = data;
        },
        templateProductData(product_data) {
            this.template_product_data = product_data.products;
        },
        ticketDetailsNotFound(data) {
            this.ticket_details_not_found = data
        }
    },
    mounted(){
        EventBus.$on('ticketFromFirebaseNotifyForComment', (data) => {
            if(data.active_tab == 'comments') {
                if(this.active_tab == 'comment') {
                    EventBus.$emit("ticketFromFirebaseNotify", {
                        active_tab: 'comments',
                    });
                } else {
                    this.active_tab = 'comment'
                    this.active_tab_body = 'comment'
                }
            } else if(data.active_tab == 'ticket_details') {
                this.active_tab = 'details'
                this.active_tab_body = 'details'
            }
        })
    },
    watch:{
        "$route.params": function (params) {
            if(params) {
                this.active_tab = 'details'
                this.active_tab_body = 'details'
            }
        },
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings
        },
    }
}
</script>
<style scoped>
    @media screen and (max-width: 768px){
        .mob-list-scroll-ticket-details{
            min-width: 700px;
        }
    }
</style>